import React, { createContext, useReducer } from "react"
import Reducer from './Reducer'
import localization from './Localization'

const defaultLanguage = "english"
const initialState = {
    localization: localization,
    language: defaultLanguage,
    strings: localization[defaultLanguage]
}

const Store = ({children}) => {
    const [state, dispatch] = useReducer(Reducer, initialState)
    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    )
}

export const Context = createContext(initialState)
export default Store